module.exports = __webpack_public_path__ + "static/media/done.918a38eb.svg";